// extracted by mini-css-extract-plugin
export default {"container":"ImageContent_container__OyW7v"};